import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions';

export interface calculatorState {
    shareCalculatorConfig: any;
    shareWithCustomerDetails: any;
    shareCalcBtnClicked: boolean;
    shareCalculatorImage: boolean;
    customerFromSharedLinkDetails: any;
    sipLumpsumCalculatorFormValues: any;

}
const rawState: calculatorState = {
    shareCalculatorConfig: null,
    shareWithCustomerDetails: null,
    shareCalcBtnClicked: false,
    shareCalculatorImage: false,
    customerFromSharedLinkDetails: null,
    sipLumpsumCalculatorFormValues: {}
};

const intialState = fromJS(rawState);

export default function investmentCalculatorReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.SET_SHARE_CALCULATOR_CONFIG:
            return merge(state, fromJS({ shareCalculatorConfig: action.payload }));
        case Actions.SET_SHARE_CALCULATOR_CUSTOMER_DETAILS:
            return merge(state, fromJS({ shareWithCustomerDetails: action.payload.data, shareCalcBtnClicked: action.payload.show }));
        case Actions.SHARE_CALCULATOR_VIA_WHATSAPP:
            return merge(state, fromJS({ shareCalculatorImage: action.payload }));
        case Actions.SET_CUSTOMER_FROM_SHARED_LINK_DETAILS:
            return merge(state, fromJS({ customerFromSharedLinkDetails: action.payload }));
        case Actions.SET_SIP_LUMPSUM_CALCULATOR_FORM_CHANGES:            
            return merge(state, fromJS({ sipLumpsumCalculatorFormValues: action.payload }));
        default:
            return state;
    }
}
